import React, { useState, useEffect } from 'react';
import FormControl from '@material-ui/core/FormControl';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import Slider from '@material-ui/core/Slider';
import Button from '@material-ui/core/Button';
import history from '../history';
import { connect } from 'react-redux';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import { Field } from 'react-final-form-html5-validation'
import { Form } from 'react-final-form';
import api from '../api';
import zxc from 'zxcvbn';
import {
  saveMainConfig, showSpinner, hideSpinner, getLocalSettings, saveLocalSettings
} from '../redux/actions';

const useStyles = makeStyles(theme => ({
  root: {
    padding: '20px 2em',
    margin: '30px auto 20px',
  },
  formControl: {
    display: 'block',
    maxWidth: 650,
    margin: '0 auto',
    '& h3': {
      color: '#9b9b9b',
      margin: '20px 0 5px',
    },
  },
  formControl2: {
    display: 'block',
    maxWidth: 650,
    margin: '0 auto',
    backgroundColor: '#f9f9f9',
    boxSizing: 'border-box',
    marginTop: '2em',
    padding: '1em',
    border: '1px solid #cacaca',
    borderRadius: 3,
    '& h3': {
      color: '#6e6e6e',
      margin: '20px 0 5px',
      marginTop: 0,
    },
  },
  passChange: {
    display: 'flex',
    width: '100%',
    '& > div': {
      width: '33%',
      marginLeft: '1%',
      '&:first-child': {
        marginLeft: 0,
      },
    },
  },
  passInput: {

  },
  passScore0: {
    margin: 0,
    color: 'red',
    fontWeight: 500,
  },
  passScore1: {
    margin: 0,
    color: '#ff7200',
    fontWeight: 500,
  },
  passScore2: {
    margin: 0,
    color: '#0098c2',
    fontWeight: 500,
  },
  passScore3: {
    margin: 0,
    color: '#3f51b5',
    fontWeight: 500,
  },
  passScore4: {
    margin: 0,
    color: 'green',
    fontWeight: 500,
  },
  slider: {
    padding: '22px 0px',
    '& .MuiSlider-track': {
      backgroundColor: theme.palette.secondary.main,
    }
  },
  btnWrap: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'center',
  },
  error: {
    color: 'red',
  },
  action: {
    marginTop: 30,
    textAlign: 'right',
    '& button': {
      margin: '0 10px',
    }
  }
}));

const isDevelopment = process.env.NODE_ENV === 'development';

function Settings(props) {
  const classes = useStyles();
  const [currentPass, setCurrentPass] = useState('');
  const [newPass, setNewPass] = useState('');
  const [passScore, setPassScore] = useState(0);
  const [audioVolume, setAudioVolume] = useState(0);
  const [soundsVolume, setSoundsVolume] = useState(0);
  const [messageNotification, setMessageNotification] = useState(false);
  const [twoWeeksReminder, setTwoWeeksReminder] = useState(false);
  const [lastLoginInfo, setLastLoginInfo] = useState(false);
  const [simpleNotes, setSimpleNotes] = useState(false);
  const [testing, setTesting] = useState(false);
  const [view, setView] = useState('change-pass'); // change-pass, pass-change-ok, pass-error
  const [saveBandwidth, setSaveBandwidth] = useState(false);

  useEffect(() => {
    const {
      messageNotification, twoWeeksReminder, lastLoginInfo, audioVolume, soundsVolume, simpleNotes, testing
    } = props.config.main;
    setAudioVolume(audioVolume);
    setSoundsVolume(soundsVolume);
    setMessageNotification(messageNotification);
    setTwoWeeksReminder(twoWeeksReminder);
    setLastLoginInfo(lastLoginInfo);
    setSimpleNotes(simpleNotes);
    setTesting(testing);
    const localSettings = getLocalSettings();
    const { saveBandwidth } = localSettings;
    setSaveBandwidth(saveBandwidth);
    // eslint-disable-next-line
  }, []);

  const handleAudioVolumeChange = (event, value) => {
    setAudioVolume(value);
  };

  const handleSoundsVolumeChange = (event, value) => {
    setSoundsVolume(value);
  };

  const saveSettings = () => {
    const config = {
      messageNotification, twoWeeksReminder, lastLoginInfo, audioVolume, soundsVolume, simpleNotes, testing
    }
    props.saveMainConfig(config);
    saveLocalSettings({ saveBandwidth });
    history.goBack();
  }

  const onPassChange = () => {
    const currentPassword = currentPass;
    const newPassword = newPass;
    const data = { currentPassword, newPassword };
    const options = {
      method: 'post',
      data: data,
      url: '/password',
      withCredentials: true,
    }
    props.showSpinner();
    api(options)
      .then(response => {
        setView('pass-change-ok');
      })
      .catch(e => {
        setView('pass-error');
      })
      .finally(ev => {
        props.hideSpinner();
      });

  }

  const onCurrentPassChange = (ev) => {
    const currentPass = ev.target.value;
    setCurrentPass(currentPass);
  }

  const onNewPassChange = (ev) => {
    const newPass = ev.target.value;
    const passScore = zxc(newPass).score;
    setNewPass(newPass);
    setPassScore(passScore);
  }

  const renderPassChange = () => {
    const passLen = newPass.length;

    return (
      <>
        <Form
          onSubmit={onPassChange}
          render={({ handleSubmit, pristine, invalid }) => (
            <form onSubmit={handleSubmit} className={classes.passChange}>
              <Field name="currentPass">
                {({ input, meta }) => (
                  <FormControl margin="normal">
                    <InputLabel htmlFor="currentPass">Obecne hasło</InputLabel>
                    <Input {...input}
                      autoComplete="off"
                      type="password"
                      autoCorrect="off"
                      autoCapitalize="off"
                      value={currentPass}
                      onChange={onCurrentPassChange}
                      className={classes.passInput}
                    />
                  </FormControl>
                )}
              </Field>
              <Field name="newPass">
                {({ input, meta }) => (
                  <FormControl margin="normal">
                    <InputLabel htmlFor="newPass">Nowe hasło</InputLabel>
                    <Input  {...input}
                      autoComplete="off"
                      type="password"
                      value={newPass}
                      onChange={onNewPassChange}
                      className={classes.passInput}
                    />
                  </FormControl>
                )}
              </Field>
              <div className={classes.btnWrap}>
                <Button
                  size="small"
                  variant="outlined"
                  type="submit"
                  color="primary"
                  className={classes.submit}
                  disabled={passScore < 2 || currentPass.length === 0}
                >
                  Zmień hasło
                </Button>
              </div>
            </form>
          )}
        />
        {passLen > 0 && passScore < 1 && <p className={classes.passScore0}>Hasło bardzo słabe</p>}
        {passLen > 0 && passScore === 1 && <p className={classes.passScore1}>Hasło niewystarczające</p>}
        {passLen > 0 && passScore === 2 && <p className={classes.passScore2}>Hasło słabe</p>}
        {passLen > 0 && passScore === 3 && <p className={classes.passScore3}>Hasło dobre</p>}
        {passLen > 0 && passScore > 3 && <p className={classes.passScore4}>Hasło bardzo dobre :)</p>}
      </>
    );
  }

  const renderPassError = () => {
    const { classes } = props;
    const tryAgain = () => {
      setCurrentPass('');
      setView('change-pass');
    }

    return (
      <>
        <p className={classes.error}>Błąd, obecne hasło jest nieprawidłowe</p>
        <div>
          <Button
            size="small"
            variant="outlined"
            color="primary"
            onClick={tryAgain}
          >
            Spróbuj jeszcze raz
          </Button>
        </div>
      </>
    );
  }

  return (
    <div className="container">
      <Paper className={classes.root}>
        <FormControl component="fieldset" className={classes.formControl}>
          <h1>Ustawienia</h1>
          <h3>Powiadomienia</h3>
          <FormGroup>
            <FormControlLabel
              control={<Checkbox
                checked={messageNotification}
                onChange={ev => setMessageNotification(ev.target.checked)}
                value="messageNotification"
              />}
              label="Powiadamiaj mailem o nowej wiadomości na platformie"
            />
            <FormControlLabel
              control={<Checkbox
                checked={twoWeeksReminder}
                onChange={(ev) => setTwoWeeksReminder(ev.target.checked)}
                value="twoWeeksReminder"
              />}
              label="Przypominaj mi, jeśli nie logowałem się na platformie dłużej niż 14 dni"
            />
            <h3>Prywatność</h3>
            <FormControlLabel
              control={<Checkbox
                checked={lastLoginInfo}
                onChange={(ev) => setLastLoginInfo(ev.target.checked)}
                value="lastLoginInfo"
              />}
              label="Pokazuj datę ostatniego logowania na stronie grupy"
            />
            <h3>Rozwiązywanie problemów</h3>
            <FormControlLabel
              control={<Checkbox
                checked={simpleNotes}
                onChange={(ev) => setSimpleNotes(ev.target.checked)}
                value="simpleNotes"
              />}
              label="Używaj uproszczonego widoku notatek"
            />
            <FormControlLabel
              control={<Checkbox
                checked={saveBandwidth}
                onChange={(ev) => setSaveBandwidth(ev.target.checked)}
                value="saveBandwidth"
              />}
              label="Oszczędzaj transfer"
            />
            {isDevelopment && <>
              <h3>Testowanie</h3>
              <FormControlLabel
                control={<Checkbox checked={testing} onChange={() => setTesting(!testing)} />}
                label="Tryb testowy - Dostęp do wszystkich odcinków, statystyki itp"
              />
            </>}
          </FormGroup>
          <h3>Dźwięki</h3>
          <Typography id="audioAudioVolume-label">Głośność odtwarzanych materiałów</Typography>
          <Slider
            className={classes.slider}
            value={audioVolume}
            onChange={handleAudioVolumeChange}
          />
          <Typography id="soundsAudioVolume-label">Głośność dźwięków platformy</Typography>

          <Slider
            className={classes.slider}
            value={soundsVolume}
            onChange={handleSoundsVolumeChange}
          />
          <div className={classes.action}>
            <Button onClick={history.goBack}>Anuluj</Button>
            <Button onClick={saveSettings} variant="contained" color="primary">Zapisz</Button>
          </div>
        </FormControl>
        <FormControl component="fieldset" className={classes.formControl2}>
          <h3>Zmiana hasła</h3>
          {view === 'change-pass' && renderPassChange()}
          {view === 'pass-change-ok' && <p>Hasło pomyślnie zmienione</p>}
          {view === 'pass-error' && renderPassError()}
        </FormControl>
      </Paper>
    </div>
  );
}

const mapStateToProps = (state) => {
  return { config: state.config };
}

export default connect(mapStateToProps, {
  saveMainConfig, showSpinner, hideSpinner
})(Settings);